// ** Auth Endpoints
export default {
  loginEndpoint: `${process.env.REACT_APP_BACKEND_URL}${process.env.REACT_APP_ACCOUNT_CLIENT_URL}me-token/`,
  registerEndpoint: "/jwt/register",
  refreshEndpoint: "/jwt/refresh-token",
  logoutEndpoint: "/jwt/logout",

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
